import { configureStore } from '@reduxjs/toolkit';
import {
  type TypedUseSelectorHook,
  useDispatch as originalUseDispatch,
  useSelector as originalUseSelector,
} from 'react-redux';

import backdrop from './backdropSlice';
import companyAccount from './companyAccountSlice';
import dataExchanges from './dataExchangesSlice';
import filters from './filtersSlice';
import userinfo from './userinfoSlice';

const store = configureStore({
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
  reducer: {
    backdrop,
    companyAccount,
    dataExchanges,
    filters,
    userinfo,
  },
});

if (import.meta.env.MODE === 'development' || import.meta.env.MODE === 'test') {
  globalThis.store = store;
}

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useDispatch = () => originalUseDispatch<AppDispatch>();
export const useSelector: TypedUseSelectorHook<RootState> = originalUseSelector;

export default store;
